angular.module('charts')
    .directive('dblStandardsPopover', [
        '$templateRequest',
        '$timeout',
        'translateFilter',
    function(
        $templateRequest,
        $timeout,
        translateFilter
    ) {

    // only want one of these open at once
    $(document).on('click', function (e) {
        $('dbl-standards-popover,[dbl-standards-popover]').each(function () {
            // don't do anything here if component was clicked or a popover was clicked
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover-dbl-standards').has(e.target).length === 0) {

                // Only hide if open.  Hiding before first open was causeing some popovers
                // to never show.
                var bsPopover = $(this).data('bs.popover');
                var popover = bsPopover ? bsPopover.tip() : undefined;
                if (popover && popover.hasClass('in')) {
                    $(this).popover('hide');
                }
            }
        });
    });

    return {
        restrict: 'AE',
        scope: {
            dblShowClusterLabels: '=',
            dblStandards: '='
        },
        controller: ['$compile', '$element', '$scope', function ($compile, $element, $scope) {
          var statusToClass = {
            GROUP_PROFICIENT: 'indicator-completed',
            PROFICIENT: 'indicator-circle-proficient',
            IN_PROGRESS: 'indicator-circle-in-progress',
            NEEDS_ATTENTION: 'indicator-needs-attention',
            NOT_STARTED: 'indicator-circle-not-started'
          };

          var statusToLabel = {
            GROUP_PROFICIENT: translateFilter('standards.proficient'),
            PROFICIENT: translateFilter('standards.proficient'),
            IN_PROGRESS: translateFilter('standards.inProgress'),
            NEEDS_ATTENTION: translateFilter('standards.mayNeedAttention'),
            NOT_STARTED: translateFilter('standards.notStarted')
          };
            // Specifying a template allows us to add our own class to popovers from this component.
            // Also we don't need a title element.
            var popoverOptions = {
                animation: false, // false fixes failure to fade in entirely on Safari
                html: true,
                placement: 'bottom',
                template: '<div class="popover popover-dbl-standards" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>',
                trigger: 'manual'
            };

            var clusterTemplateUrl = '/resources/charts/directives/standards-popover/dbl-standards-popover.directive.html';

            function popoverClick (e) {
                $(this).popover('toggle');
            }

            $scope.indicatorClass = function (dblProficiencyStatus){
              return statusToClass[dblProficiencyStatus];
            };

            $scope.label = function (dblProficiencyStatus){
              var defaultStatus = 'NOT_STARTED';
              var label = statusToLabel[dblProficiencyStatus];
              return  label ? label : statusToLabel[defaultStatus];
            };

            // Try to preload the template for the list of clusters/standards.  This eliminates
            // flakiness in the first time dbl-standards-popover is rendered.
            var templatePromise = $templateRequest(clusterTemplateUrl);

            $scope.$watch('dblStandards', function (value) {
                if (value) {
                    templatePromise.then(function (template) {
                        var clusterListElement = $compile(template)($scope);

                        // without timeout the clusterListElement html doesn't get rendered in time
                        $timeout(function () {
                            popoverOptions.content = clusterListElement.html();
                            $element.popover(popoverOptions).on('click', popoverClick);
                        });

                    });
                }

            });
        }]
    };
}]);
